import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import MyApp from "./App";
import { Theme } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Theme
      accentColor="green"
      grayColor="slate"
      radius="full"
      scaling="100%"
      panelBackground="translucent"
      style={{ backgroundColor: "black", color: "white" }}
      appearance="dark"
    >
      <MyApp />
    </Theme>
  </React.StrictMode>
);
